import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is the Recovery Experience?",
    a: "A complimentary, staff-guided recovery session at our North Phoenix studio. Our team selects 2–3 signature modalities around your goals — whether that's less pain, better sleep, faster recovery or more energy — and walks you through every minute."
  },
  {
    q: "Is it really free?",
    a: "Yes. The Recovery Experience is completely complimentary, with no payment and no obligation. We want you to feel the difference deliberate recovery makes before deciding anything."
  },
  {
    q: "Which modalities might my session include?",
    a: "Depending on your goals, your session may feature Cold Plunge, Infrared Sauna, Red Light, Compression, Halo Therapy, PEMF, Hyperbaric Oxygen or Salt Float — chosen with our staff, never at random."
  },
  {
    q: "What is the Infinity Capsule?",
    a: "The Infinity Capsule is our newest piece of recovery technology — a first-of-its-kind immersive session coming to the North Phoenix floor. Ask about it during your visit; you'll be among the first to see it."
  },
  {
    q: "Do I need to be an athlete?",
    a: "Not at all. Our guests range from competitive athletes to busy professionals who simply want to sleep better, hurt less and have more energy. Your session is built around your goals."
  },
  {
    q: "How long is the session and what should I bring?",
    a: "Plan for about an hour including your guided tour. Bring comfortable athletic wear and a water bottle — we provide towels and everything else."
  }
];

export const FAQ = () => (
  <section id="faq" className="mx-auto max-w-4xl px-5 py-28 md:px-10 md:py-40" data-testid="faq-section">
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
    >
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Questions</p>
      <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-5xl">Before you commit</h2>
    </motion.div>

    <Accordion type="single" collapsible className="mt-12">
      {faqs.map((f, i) => (
        <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
          <AccordionTrigger
            data-testid={`faq-trigger-${i}`}
            className="py-6 text-left font-display text-lg font-bold uppercase tracking-tight hover:text-rest-red hover:no-underline md:text-xl"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-sm leading-relaxed text-zinc-400 md:text-base" data-testid={`faq-content-${i}`}>
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
